<template>
    <div>
        <!-- 面包屑 -->
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       style="font-size: 20px; padding: 20px 10px 20px; background-color: #e6e5e5;">
            <el-breadcrumb-item>Generation</el-breadcrumb-item>
            <el-breadcrumb-item>Sequence-based</el-breadcrumb-item>
        </el-breadcrumb>
        <p class="content">
            The EncDecLM module enables target-specific molecular generation from protein
            sequence input. Users provide an amino acid sequence in FASTA format, and the
            server performs sequence-conditioned generation within the unified platform.
            The underlying Transformer-based encoder–decoder model was developed in the
            original study and is deployed here for practical use. Generated molecules are
            returned as SMILES strings, together with predicted molecular properties and
            interactive visualization results.  </p>
        <!-- 表单 -->
        <EncDecLMForm></EncDecLMForm>
    </div>
</template>

<script>
    import EncDecLMForm from "@/components/EncDecLMForm";

    export default {
        name: "SequenceBased",
        components: {
            EncDecLMForm
        }
    }
</script>

<style scoped>
    div {
        max-width: 1160px;
        margin: 0 auto;
    }

    p {
        /*padding: 20px 0 20px;*/
        line-height: 1.5em;
        text-align: left;
    }

    .content{
        box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
        background-color: RGB(255,255,255);
        border-radius: 10px;
        padding: 10px;
    }
</style>
